import { useCallback, useEffect } from 'react';

import { isApplicationModeInfinity } from 'src/data/system';
import type { VoidFunction } from 'src/lib/types';
// @ts-expect-error - CustomerStore is not typed yet
import { useCurrentCustomerId } from 'src/store/customer';
// @ts-expect-error - useNotificationsCenterActions is not typed yet
import { useNotificationsCenterActions } from 'src/store/notifications';

import { areCustomerNotifications } from '../lib';

const NOTIFICATIONS_POOLING_INTERVAL = 60 * 1000; // 1 min

export const useMaintainNotifications = (refreshCustomer: VoidFunction) => {
  const currentCustomerId = useCurrentCustomerId();
  const notificationsCenterActions = useNotificationsCenterActions();

  // Update notifications each `NOTIFICATIONS_POOLING_INTERVAL`
  const pullNotifications = useCallback(async () => {
    if (!currentCustomerId) {
      return;
    }

    const notifications = await notificationsCenterActions.queryNotifications(currentCustomerId);

    // If one of received notifications is about customer changes, we should refresh customer data right away
    if (areCustomerNotifications(notifications)) {
      refreshCustomer();
    }
  }, [currentCustomerId, notificationsCenterActions, refreshCustomer]);

  useEffect(() => {
    // Do not pull notifications in Infinity mode, as we are not displaying them there and do not want to make unnecessary API calls
    if (isApplicationModeInfinity()) {
      return;
    }

    void pullNotifications();

    const interval = setInterval(pullNotifications, NOTIFICATIONS_POOLING_INTERVAL);
    return () => clearInterval(interval);
  }, [pullNotifications]);
};
